import Vue from 'vue'
import * as formats from './format'
import * as dictionaries from './dictionary'

const filters = [
    formats,
    dictionaries
]

filters.forEach(filter => {
    Object.keys(filter).forEach(key => {
        Vue.filter(key, filter[key])
    });
});
